const showBillingAddressFieldsReducer = (state = false, action) => {
	switch(action.type){
	case 'SHOWADDRESSFIELDSTRUE':	
		return true;
	case 'SHOWADDRESSFIELDSFALSE':
		return false;
	default:
		return state;
	}
}

export default showBillingAddressFieldsReducer;